import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Pricing = () => {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="pricing" className="pricing">
      <div className="container">
        <div className="section-header">
          <h2>{t('pricing-title')}</h2>
          <p>{t('pricing-subtitle-alt')}</p>
        </div>
        
        <div className="pricing-content">
          <div className="pricing-grid">
            {/* Europe Package */}
            <div className="pricing-card featured">
              <div className="badge">{t('pricing-most-popular')}</div>
              <div className="pricing-header">
                <h3>{t('pricing-europe-title')}</h3>
                <div className="price">€1,899</div>
                <p>{t('pricing-europe-desc')}</p>
              </div>
              <ul className="features">
                <li><i className="fas fa-check"></i> <span>{t('feature-company-registration')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-registered-address')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-basic-documentation')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-government-fees')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-formation-time-2-4')}</span></li>
              </ul>
              <button className="btn btn-primary" onClick={scrollToContact}>
                {t('btn-get-started')}
              </button>
            </div>

            {/* Offshore Package */}
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>{t('pricing-offshore-title')}</h3>
                <div className="price">€1,299</div>
                <p>{t('pricing-offshore-desc')}</p>
              </div>
              <ul className="features">
                <li><i className="fas fa-check"></i> <span>{t('feature-company-registration')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-registered-address')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-nominee-services')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-basic-documentation')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-formation-time-1-3')}</span></li>
              </ul>
              <button className="btn btn-primary" onClick={scrollToContact}>
                {t('btn-get-started')}
              </button>
            </div>

            {/* Global Hub Package */}
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>{t('pricing-global-title')}</h3>
                <div className="price">€3,599</div>
                <p>{t('pricing-global-desc')}</p>
              </div>
              <ul className="features">
                <li><i className="fas fa-check"></i> <span>{t('feature-company-registration')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-registered-address')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-banking-assistance')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-government-fees')}</span></li>
                <li><i className="fas fa-check"></i> <span>{t('feature-formation-time-3-5')}</span></li>
              </ul>
              <button className="btn btn-primary" onClick={scrollToContact}>
                {t('btn-get-started')}
              </button>
            </div>
          </div>

          <div className="advanced-packages-cta">
            <div className="advanced-cta-content">
              <div className="advanced-cta-text">
                <h3>{t('advanced-features-title')}</h3>
                <p>{t('advanced-features-desc')}</p>
              </div>
              <div className="advanced-cta-action">
                <button className="btn btn-secondary" onClick={scrollToContact}>
                  <i className="fas fa-calendar-check"></i>
                  <span>{t('advanced-book-consultation')}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing; 